import { render, staticRenderFns } from "./TestDeposit.vue?vue&type=template&id=2d484de6&"
import script from "./TestDeposit.vue?vue&type=script&lang=js&"
export * from "./TestDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports